let Constants = {
  API_ENDPOINT: "https://api-finiper2020.mulinobianco.it",
  API_TOKEN: "ec2dd564-e098-11ea-b577-0242ac10ee0c",
  PROMO_CODE: "463",
  CH_PROMO: "CH_463_MLB_WEB_DONAFELI20_CRS_FIN_20201001_20201030",
  CLOSING_STEP_1_DATE: "30/10/2020 24:00",
  WINNING_SESSION_COOKIE_NAME: "cndpromowinsesiper",
};

export default Constants;
